import UserPasswordEditStep from './UserPasswordEditStep';
import { withPopup } from './Utils';

export default withPopup(UserPasswordEditStep);
